import { __decorate } from "tslib";
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import { URLS } from '@/common/js/constant/index';
import { accountRules } from '@/common/js/form-rule/index';
import Back from './common-back.vue';
let DrawerSetSubAccountPwd = class DrawerSetSubAccountPwd extends Vue {
    constructor() {
        super(...arguments);
        this.form = {
            password: '',
            confirm_password: '',
        };
        this.formRules = {};
        this.isLoading = false;
    }
    onShowChanged(val) {
        if (val) {
            this.formRules = accountRules.call(null, this.form);
        }
        else {
            const form = this.$refs.form;
            form.resetFields();
        }
    }
    save() {
        const form = this.$refs.form;
        form.validate((valid) => {
            if (valid) {
                this.isLoading = true;
                this.$ajax.post(URLS.resetPasswordByGuid, {
                    user_guid: this.info.user_guid,
                    new_password: KLOOK.md5(this.form.password),
                }).then((res) => {
                    this.$successTips();
                    this.isShowDrawer = false;
                }).finally(() => {
                    this.isLoading = false;
                });
            }
        });
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], DrawerSetSubAccountPwd.prototype, "info", void 0);
__decorate([
    PropSync('show', { type: Boolean })
], DrawerSetSubAccountPwd.prototype, "isShowDrawer", void 0);
__decorate([
    Watch('show')
], DrawerSetSubAccountPwd.prototype, "onShowChanged", null);
DrawerSetSubAccountPwd = __decorate([
    Component({
        components: {
            Back,
        },
    })
], DrawerSetSubAccountPwd);
export default DrawerSetSubAccountPwd;
